import {useEffect, useState} from "react";

export const UseValidatorField = (isValidInput, initialValue) => {
    const [dirty, setDirty] = useState(false);
    const [value, setValue] = useState(initialValue === undefined ? '' : initialValue);

    useEffect(() => {
        // Only update value if initialValue is provided and different from current value
        if (initialValue !== undefined && initialValue !== value) {
            setValue(initialValue);
        }
    }, [initialValue]);  // Dependency on initialValue

    const onBlur = () => {
        setDirty(true)
    }

    const error = () => {
        return dirty && value !== undefined && isValidInput && !isValidInput(value)
    }

    return {
        error,
        onBlur,
        value,
        setValue
    }
};
